import React from 'react';
import { Buttons } from '../../../../../Common/fCore/fButtons';
import { KeyValueDetails } from '../../../../../Common/fCore/fKeyValue';
import { Owner } from '../../../../../Common/fCore/fOwner';
import { Status } from '../../../../../Common/fCore/fStatus';
import { FloatInputButton } from '../../../../../Common/fInputs';
import { post } from '../../../../../../Model/Network/Config/Axios';
import { handleError, showToast } from '../../../../../Common/fToast/ToastCallback';
import Tds from './Tds';
import PhotoTile from '../../../../../Common/fPhoto';
import SelectGST from '../../../../../Common/fUtils/SelectGST';
import { separateCamelCase } from '../../../../../../Utils/Utils';



const Index = ({data,pending,buttons,reload,id}) => {

	const update = (key, value,isForm) => {
		let  data = {}
		if (isForm) {
			data = {
			   key,
			   value
			};
		} else {
			data[key] = value;
		}
		post(`vendor/advances/${id}/update`,data, (e, r) => {
			if (r) {
				reload()
				showToast({
					type: 'success',
					message: 'Field Updated'
				})
			} else if (e) {
				handleError(e);
			}
		});
	}
	
    return(
        <div>
            
            <Status badges={[
				{
					title:`Status : ${data.status}`,
					background:'var(--primary-color)'
				},
				{
					title:`Amount : INR ${data.amount}`,
					background:"var(--green-color)"
				}
			]}/>
             {
                pending ?
                <Buttons buttons={buttons} />
                :null
             }

             <Owner owner={data.owner} />
             <div style={{fontSize: '14px', fontWeight: 'bold',margin: '30px 0px 10px 0px'}}>PO Details</div>

            
            {
            data.po?
            <>
            <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>PO Number:</span> {data.po.poNo}</div>
            <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>Remarks:</span> {data.remarks}</div>
            <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>Vendor Name:</span> {data.vendor.name}</div>
            <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>Vendor Gstin:</span> {data.vendor.gstin}</div>
            <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>Vendor Registered Id:</span> {data.vendor.registeredId}</div>
            </>
            :<div style={{padding: '20px', border: '1px solid var(--border-color)', borderRadius: '6px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>No Information available</div>
            }
            <KeyValueDetails header="Advance Details" values={[
				{
					key:'Advance Id',
					value:data.advanceId
				},
                {
					key:'Advance Amount',
					value:data.amount
				},
                {
					key:'Base Amount',
					value:(data && data.content && data.content.baseAmount) ? data.content.baseAmount :0
				},
                {
					key:'Tax Amount',
					value:(data && data.content && data.content.taxAmount) ? data.content.taxAmount :0
				},
                {
					key:'Tds %',
					value:`${data.tds?data.tds.tds:'-'}`
				},
				{
					key:'Tds Description',
					value:`INR ${data.tds?data.tds.code:'-'}`
				},
				{
					key:'Remarks',
					value:`${data.remarks ? data.remarks :'-'}`
				},
				
			]}/>
            <div style={{fontSize: '14px', fontWeight: 'bold',margin: '30px 0px 10px 0px'}}>Advance Details</div>            
            <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>Advance Id:</span> {data.advanceId}</div>
            <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>Advance Amount:</span> {data.amount}</div>
            <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>Tds %:</span> {data.tds?data.tds.tds:'-'}</div>
            <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>Tds description:</span> {data.tds?data.tds.code:'-'}</div>  
			{
				data.attrs && Object.keys(data.attrs || {}).length > 0 ?
				Object.entries(data.attrs).map(([key,value])=>{
					return <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>{separateCamelCase(key)}:</span> {value}</div>
				}) 
				:null
			} 
			{data && data.status === "APPROVAL" ?
				<>	
					<div style={{marginTop:10}}><strong>Update Details</strong></div>
					<div style={{ display: 'flex' }}>
						<div style={{ width: '50%' }}>
							<FloatInputButton
								onSubmit={(val) => {
									update('base', Number(val))
								}} title='Base Amount '
								placeholder={(data && data.content && data.content.baseAmount) ? data.content.baseAmount : 0}
								disabled={data.status !== 'APPROVAL'}
							/>
						</div>
						<div style={{ width: '50%', paddingLeft: '10px', marginTop: 20 }}>
							<Tds id={id} value={data.tds ? data.tds.tds : '-'}
								vendorId={data.vendor && data.vendor.id}
								init={() => {
									reload()
								}}
								disabled={data.status !== 'APPROVAL'}
							/>
						</div>
					</div>
					<div style={{ display: 'flex' }}>
						<div style={{ width: '50%' }}>
							<FloatInputButton
								onSubmit={(val) => {
									update('amount', Number(val))
								}} title='Advance Amount '
								placeholder={data.amount ? data.amount : 0}
								disabled={data.status !== 'APPROVAL'}
							/>
						</div>
						<div style={{ width: '50%', paddingLeft: '10px', marginTop: 5 }}>
							<SelectGST defaultValue={(data && data.content && data.content.taxSlab) ? { label: `${data.content.taxSlab}`, value: `${data.content.taxSlab}` } 
								:
								{ label: `0`, value: `0` }
							   } placeholder="Select Gst (%)" onSelect={(val) => {
								update('taxSlab', Number(val.value))
							}}/>
						</div>
					</div>
					{
						data.forms && data.forms.length > 0 ?
							<>
								<div><strong>Forms</strong></div>
								{data.forms.map((item, index) => {
									return (
										<FloatInputButton
											onSubmit={(val) => {
												update(item.id, val, true)
											}}
											title={item.key}
											placeholder={item.value || '-'}
											disabled={data.status !== 'APPROVAL'}
										/>
									)
								})}
							</>
							: undefined
					}
				</>
				: null
			}
            {
				data.forms.length?
					<KeyValueDetails header="Custom Details" values={data.forms}/>:undefined
			}

			{
				(data.content.attachments && data.content.attachments.length>0)? 
					<div>
						<div
							style={{fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 15px 0px'}}>Attachments
						</div>
						<div style={{
							display: 'flex',
							marginLeft: '-15px',
							flexWrap: 'wrap',
							maxHeight: '250px',
							overflowY: 'scroll'
						}}>
							{
								data.content.attachments.map((item, index) => {
									return (
										<PhotoTile  key={`Photo-${index}`} link={item.path}/>
									)
								})
							}
						</div>
					</div>	:null	
			}
        </div>
    )
}

export default Index;